var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qrData.link)?_c('div',{staticClass:"donation-qr"},[_c('qr-container',{staticClass:"donation-qr-inner",attrs:{"link":_vm.qrData.link,"size":_vm.qrWidth}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.qrData.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }